module.exports = __webpack_public_path__ + "static/img/OM14.6b43b425.png";